<template>
    <div class="Popup">

    </div>
</template>

<script>
export default {
    name: 'Popup',
    created() {//Star-CD ```

    },
    mounted() {//End-EN
    },
    computed: {//CM
    },
    watch: {//WA
    },
    methods: {//event-EV
    },
    components: {//mod

    },
}
</script>

<style lang="less" scoped>

</style>




// WEBPACK FOOTER //
// src/components/common/Popup/Popup.vue